var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    {
      staticClass: "geolocation-progress",
      class: [
        {
          geoInProgessOrSuccess:
            (_vm.mgProgress.inProgress && !_vm.mgProgress.postContentFailed) ||
            (!_vm.mgProgress.inProgress && _vm.mgProgress.postContentSuccess)
        },
        {
          geoFailed:
            !_vm.mgProgress.inProgress && _vm.mgProgress.postContentFailed
        }
      ]
    },
    [
      _vm.mgProgress.inProgress &&
      !_vm.mgProgress.postContentFailed &&
      _vm.mgProgress.isFirstCheck
        ? _c(
            "v-flex",
            { staticClass: "content-wrapper" },
            [
              _c("geolocation-loader"),
              _vm._v(" "),
              _c("p", { staticClass: "text-info" }, [
                _c("span", { staticClass: "mark-text" }, [
                  _vm._v(_vm._s(_vm.$t("Geolocation.Checking")))
                ])
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.mgProgress.inProgress && _vm.mgProgress.postContentFailed
        ? _c("v-flex", { staticClass: "content-wrapper" }, [
            _c("div", { staticClass: "text-info" }, [
              _c("span", [
                _c(
                  "svg",
                  {
                    attrs: {
                      version: "1.1",
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 130.2 130.2"
                    }
                  },
                  [
                    _c("circle", {
                      staticClass: "path circle",
                      attrs: {
                        fill: "none",
                        stroke: "#fff",
                        "stroke-width": "6",
                        "stroke-miterlimit": "10",
                        cx: "65.1",
                        cy: "65.1",
                        r: "62.1"
                      }
                    }),
                    _vm._v(" "),
                    _c("line", {
                      staticClass: "path line",
                      attrs: {
                        fill: "none",
                        stroke: "#fff",
                        "stroke-width": "6",
                        "stroke-linecap": "round",
                        "stroke-miterlimit": "10",
                        x1: "34.4",
                        y1: "37.9",
                        x2: "95.8",
                        y2: "92.3"
                      }
                    }),
                    _vm._v(" "),
                    _c("line", {
                      staticClass: "path line",
                      attrs: {
                        fill: "none",
                        stroke: "#fff",
                        "stroke-width": "6",
                        "stroke-linecap": "round",
                        "stroke-miterlimit": "10",
                        x1: "95.8",
                        y1: "38",
                        x2: "34.4",
                        y2: "92.2"
                      }
                    })
                  ]
                )
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "failed" }, [
                _vm._v(
                  _vm._s(
                    _vm.mgProgress.count === 1
                      ? _vm.$t("Geolocation.ErrorMessage.CannotVerifiyLocation")
                      : _vm.$t("Geolocation.ErrorMessage.AccountIssues")
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "btn-wrapper" }, [
              _c(
                "button",
                {
                  staticClass: "custom-btn",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.view()
                    }
                  }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.mgProgress.count === 1
                        ? _vm.$t("BetSlip.geoLocation.Details")
                        : _vm.$t("Geolocation.ErrorMessage.ShowAll")
                    )
                  )
                ]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.mgProgress.inProgress &&
      _vm.mgProgress.postContentSuccess &&
      _vm.mgProgress.isFirstCheck
        ? _c(
            "v-flex",
            {
              staticClass: "content-wrapper",
              class: { "location-verified": _vm.mgProgress.postContentSuccess }
            },
            [
              _c("p", { staticClass: "text-info" }, [
                _c("span", [
                  _c(
                    "svg",
                    {
                      attrs: {
                        version: "1.1",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 130.2 130.2"
                      }
                    },
                    [
                      _c("circle", {
                        staticClass: "path circle",
                        attrs: {
                          fill: "none",
                          stroke: "#73AF55",
                          "stroke-width": "6",
                          "stroke-miterlimit": "10",
                          cx: "65.1",
                          cy: "65.1",
                          r: "62.1"
                        }
                      }),
                      _vm._v(" "),
                      _c("polyline", {
                        staticClass: "path check",
                        attrs: {
                          fill: "none",
                          stroke: "#73AF55",
                          "stroke-width": "6",
                          "stroke-linecap": "round",
                          "stroke-miterlimit": "10",
                          points: "100.2,40.2 51.5,88.8 29.8,67.5 "
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "mark-text" }, [
                  _vm._v(_vm._s(_vm.$t("Geolocation.Location.Verified")))
                ])
              ])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76c167b0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76c167b0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/parts/mobileGeolocationDialog.vue
// module id = null
// module chunks = 